import Component_PBR_64fa77f6c6bf8fd8e81a353fbc22be3b from "../../../../content/examples/textures/pbr/PBR";
import Devtool_PBR_64fa77f6c6bf8fd8e81a353fbc22be3b from "!!@devtool/loader!../../../../content/examples/textures/pbr/PBR";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_PBR_64fa77f6c6bf8fd8e81a353fbc22be3b,
  Devtool_PBR_64fa77f6c6bf8fd8e81a353fbc22be3b,
  DevTool,
  React
};